import { ReactiveRestApi } from '@unrest/vue-storage'

export default () => ReactiveRestApi()
